// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PB_MENU_SUBSCRIBED_PHOTOBLOGS = "Odober\u00e1m pr\u00edspevky";
